const packageSize= [
    {
    "ID":1,
    "name": "in"
    },{
    "ID":2,
    "name": "cm"
    }

]
export default packageSize;